module.exports = __webpack_public_path__ + "img/Inverclyde.2653aec3.png";